<template>
    <div>
        <el-dialog :title="$t('addAdvertCrop')"
                   :visible.sync="dialogVisible"
                   :close-on-click-modal="false"
                   @close="dialogClose"
                   center
                   top="5vh"
                   width="1100px">
            <div class="content">
                <div class="drawing">
                    <div class="cropper" style="width: 600px; height: 600px">
                        <vue-cropper
                            ref="cropper"
                            :img="option.img"
                            :outputSize="option.outputSize"
                            :outputType="option.outputType"
                            :info="option.info"
                            :canScale="option.canScale"
                            :autoCrop="option.autoCrop"
                            :autoCropWidth="option.autoCropWidth"
                            :autoCropHeight="option.autoCropHeight"
                            :fixed="option.fixed"
                            :full="option.full"
                            :fixedBox="option.fixedBox"
                            :canMove="option.canMove"
                            :canMoveBox="option.canMoveBox"
                            :original="option.original"
                            :centerBox="option.centerBox"
                            :high="option.high"
                            :infoTrue="option.infoTrue"
                            :maxImgSize="option.maxImgSize"
                            :enlarge="option.enlarge"
                            :mode="option.mode"
                            @realTime="realTime">
                        </vue-cropper>
                    </div>
                    <!--预览效果图-->
                    <div class="preview">
                        <div :style="previews.div" class="preview-img">
                            <img :src="previews.url" :style="previews.img">
                        </div>
                        <div class="preview-handle">
                            <el-button size="mini" type="primary" @click="uploadImageSlice()">{{$t('uploadSlicing')}}</el-button>
                            <el-button size="mini" type="primary" @click="previewDialog = true">{{$t('preview')}}</el-button>
                            <!--<el-button size="mini" type="primary" @click="parseTextContent" v-if="!sliceContentShow">{{$t('parseSlicingContent')}}</el-button>-->
                            <!--<el-popover-->
                            <!--    v-else-->
                            <!--    placement="top"-->
                            <!--    :title="$t('slicingContent')"-->
                            <!--    width="300"-->
                            <!--    trigger="hover"-->
                            <!--    :content="sliceContent">-->
                            <!--    <el-button size="mini" type="primary" slot="reference">{{$t('slicingContent')}}</el-button>-->
                            <!--</el-popover>-->
                        </div>
                        <div class="preview-form" v-show="cropObj.url">
                            <div class="image-slice">
                                <el-image
                                    :src="cropObj.url"
                                    fit="contain"></el-image>
                            </div>
                            <el-form :model="formData"
                                     :rules="rules"
                                     ref="ruleForm"
                                     label-width="110px">
                                <el-form-item :label="$t('goodsName')"
                                              prop="name">
                                    <el-input v-model="formData.name"
                                              autocomplete="off"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('originPrice')"
                                              prop="originalPrice">
                                    <el-input v-model="formData.originalPrice"
                                              autocomplete="off" v-input-float>
                                        <template slot="append">€</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item :label="$t('marketPrice')"
                                              prop="currentPrice">
                                    <el-input v-model="formData.currentPrice"
                                              autocomplete="off" v-input-float>
                                        <template slot="append">€</template>
                                    </el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
        
            </div>
            <div slot="footer"
                 class="dialog-footer">
                <el-button size="mini" @click="dialogVisible = false">{{ $t('close') }}</el-button>
                <el-button type="primary"
                           :disabled="disabled"
                           size="mini"
                           @click="submitForm('ruleForm')" v-if="cropObj.url">{{ $t('confirm') }}</el-button>
            </div>
        </el-dialog>
        <!-- 预览 -->
        <Preview
            :parent-dialog="previewDialog"
            :parent-id="advertPaperId"
            :parent-image="advertImage"
            @parent-close="previewDialog = false"/>
    </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import {formatNum} from '@/utils/common'
import {createAdvertCropper, uploadImage, uploadAdvertTextSlice} from "@/api/modules/api";
import {mapState} from "vuex";
// 预览
import Preview from '@/components/advert/paper/Preview'
export default {
    name: 'Add',
    components: {
        VueCropper,
        Preview
    },
    props: {
        parentDialog: {
            type: Boolean,
            default: true
        },
    },
    data () {
        return {
            dialogVisible: false,
            previews: {},
            option: {
                img: '',             //裁剪图片的地址
                outputSize: 1,       //裁剪生成图片的质量(可选0.1 - 1)
                outputType: 'png',  //裁剪生成图片的格式（jpeg || png || webp）
                info: true,          //图片大小信息
                canScale: true,      //图片是否允许滚轮缩放
                autoCrop: true,      //是否默认生成截图框
                autoCropWidth: 100,  //默认生成截图框宽度
                autoCropHeight: 100, //默认生成截图框高度
                fixed: false,         //是否开启截图框宽高固定比例
                fixedNumber: [1.53, 1], //截图框的宽高比例
                full: false,         //false按原比例裁切图片，不失真
                fixedBox: false,      //固定截图框大小，不允许改变
                canMove: true,      //上传图片是否可以移动
                canMoveBox: true,    //截图框能否拖动
                original: true,     //是否按照设备的dpr 输出等比例图片
                centerBox: true,    //截图框是否被限制在图片里面
                high: true,        //是否按照设备的dpr 输出等比例图片
                infoTrue: false,     //true为展示真实输出图片宽高，false展示看到的截图框宽高
                maxImgSize: 5000,    //限制图片最大宽度和高度
                enlarge: 1,          //图片根据截图框输出比例倍数
                mode: 'contain'  //图片默认渲染方式 contain , cover, 100px, 100% auto
            },
            cropObj: {
                url: '',   // 切图url
                lengthCoordinate: 0,   // 切图左上角相对底图x坐标（相对于底图的百分比）
                highCoordinate: 0,     // 切图左上角相对底图y坐标（相对于底图的百分比）
                lengthProportion: 0,   // 切图与底图宽比
                highProportion: 0,     // 切图与底图高比
            },
            formData: {
                name: '',
                originalPrice: '',
                currentPrice: ''
            },
            rules: {
                name: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                originalPrice: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                currentPrice: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
            },
            sliceContent: '',   // 切片内容
            sliceContentShow: false,   // 是否显示查看切片内容按钮
            disabled: false,
            previewDialog: false
        }
    },
    // 计算属性
    computed: {
        ...mapState('other', ['advertBookId', 'advertPaperId', 'advertImage']),
    },
    watch: {
        parentDialog (val) {
            if (val) {
                this.initData()
            }
        },
    },
    methods: {
        // 初始化数据
        initData () {
            this.dialogVisible = true
            this.cropObj = {
                url: '',   // 切图url
                lengthCoordinate: 0,
                highCoordinate: 0,
                lengthProportion: 0,
                highProportion: 0,
            }
            // 图片链接
            this.option.img = this.advertImage
            // 切片文字内容
            this.sliceContent = ''
            // 是否显示查看切片内容按钮
            this.sliceContentShow = false
        },
        
        //实时预览函数
        realTime(data) {
            this.previews = data
            this.sliceContentShow = false
        },
        
        //上传切图
        uploadImageSlice() {
            this.$refs.cropper.getCropBlob(data => {
                let file = new File([data], '01.png');
                let formData = new FormData();
                formData.append('file', file)
                uploadImage(formData).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        // 保存切图url
                        let url = res.data.url || ''
                        // 获取当前切图信息
                        this.getNowSliceInfo(url)
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: err,
                        type: 'error'
                    })
                })
            })
        },
    
        //解析切图内容
        parseTextContent() {
            this.$refs.cropper.getCropBlob(data => {
                let file = new File([data], '01.png');
                let formData = new FormData();
                formData.append('file', file)
                uploadAdvertTextSlice(formData).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        // 切片内容
                        this.sliceContent = res.data.text
                        // 切片内容显示按钮
                        this.sliceContentShow = true
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: err,
                        type: 'error'
                    })
                })
            })
        },
    
        // 获取当前切图信息
        getNowSliceInfo (url) {
            // 底图基于容器的坐标点
            let img = this.$refs.cropper.getImgAxis()
            // 截图框基于容器的坐标点
            let crop = this.$refs.cropper.getCropAxis()
            // 截图框相对底图x轴坐标（相对于底图的百分比）
            let lengthCoordinate = (crop.x1 - img.x1) / (img.x2 - img.x1)
            lengthCoordinate = formatNum(lengthCoordinate, 4)
            // 截图框相对底图y轴坐标（相对于底图的百分比）
            let highCoordinate = (crop.y1 - img.y1) / (img.y2 - img.y1)
            highCoordinate = formatNum(highCoordinate, 4)
            // 截图框与底图宽度比
            let lengthProportion = (crop.x2 - crop.x1) / (img.x2 - img.x1)
            lengthProportion = formatNum(lengthProportion, 4)
            // 截图框与底图高度比
            let highProportion = (crop.y2 - crop.y1) / (img.y2 - img.y1)
            highProportion = formatNum(highProportion, 4)
            this.cropObj = {
                url,
                lengthCoordinate,
                highCoordinate,
                lengthProportion,
                highProportion
            }
    
        },
    
        // 验证表单
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sendRequest()
                } else {
                    return false
                }
            })
        },
        // 重置表单
        resetForm (formName) {
            this.$refs[formName].resetFields()
        },
        
        // 提交
        sendRequest () {
            // 折扣百分比
            let discountProportion = (this.formData.currentPrice / this.formData.originalPrice) * 100
            discountProportion = formatNum(discountProportion, 2)
            const params = {
                showcaseItemId: this.advertPaperId,
                showcaseId: this.advertBookId,
                name: this.formData.name.trim(),
                originalPrice: this.formData.originalPrice,
                currentPrice: this.formData.currentPrice,
                discountProportion,
                image: this.cropObj.url,
                lengthCoordinate: this.cropObj.lengthCoordinate,
                highCoordinate: this.cropObj.highCoordinate,
                lengthProportion: this.cropObj.lengthProportion,
                highProportion: this.cropObj.highProportion,
            }
            this.disabled = true;
            createAdvertCropper(params).then((res) => {
                if (Number(res.code) === 20000) {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'success'
                    })
                    // 重置表单
                    this.resetForm('ruleForm')
                    this.$emit('parent-update')
                    this.cropObj = {
                        url: '',   // 切图url
                        lengthCoordinate: 0,
                        highCoordinate: 0,
                        lengthProportion: 0,
                        highProportion: 0,
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            }).finally(() => {
                this.disabled = false;
            })
        },
    
        // 预览
        previewHandle () {
            this.previewDialog = true
        },
        
        // 关闭弹窗
        dialogClose () {
            // 重置表单
            this.resetForm('ruleForm')
            this.$emit('parent-close')
        }
    },
    created () { },
    mounted () {
    
    },
}
</script>

<style scoped lang="scss">
.content{
    width: 100%;
    max-height: 720px;
    overflow-y: auto;
    .drawing{
        width: 100%;
        display: flex;
        .cropper{
            flex-shrink: 0;
        }
        .preview{
            flex-grow: 1;
            height: 100%;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            .preview-img {
                overflow: hidden;
                border: 1px solid #67c23a;
                background: #cccccc;
            }
            .preview-handle{
                margin-top: 10px;
                margin-bottom: 20px;
                ::v-deep .el-button{
                    margin: 10px;
                }
            }
            .preview-form{
                width: 100%;
                .image-slice{
                    width: 100%;
                    height: 200px;
                    display: flex;
                    justify-content: center;
                    margin-bottom: 10px;
                    ::v-deep .el-image{
                        width: 200px;
                        height: 200px;
                    }
                }
                ::v-deep .el-form{
                    width: 100%;
                    padding-left: 20px;
                    padding-right: 20px;
                }
            }
            
        }
    }
    
}
</style>
